// ./client/components/Reports/Graphs.js
import React from "react";
import { useAppContext } from "../../context/appContext";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

function BusinessReports() {
  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

  const { reports } = useAppContext();

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
        text: "FreeLite Metrics",
      },
    },
  };

  const yearLabels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dayLabels = Array.from({ length: 30 }, (_, i) => i + 1);

  const fillData = () => {
    let data;

    const relAppts = reports.appointments?.filter(
      (appt) => appt.appt_date >= reports.startDate && appt.appt_date <= reports.endDate
    );
    console.log("relAppts:", relAppts);

    data = dayLabels.map((day) => {
      const date = new Date(reports.startDate);
      date.setDate(date.getDate() + (day - 1)); // (day - 1) first day is 0 days after start
      const formattedDate = date.toISOString().split("T")[0];

      // console.log("formattedDate:", formattedDate);

      const dayAppts = reports.appointments?.filter((appt) => {
        return appt.appt_date?.split("T")[0] === formattedDate;
      });
      return dayAppts?.length;
    });

    return data;
  };

  const myData = {
    labels: reports?.dataLabels || dayLabels,
    datasets: [
      {
        label: reports?.datasetLabel,
        data: reports?.dataSet || fillData(),
        fill: true,
        borderColor: "rgb(75, 192, 192)",
        tension: 0.2,
      },
    ],
  };

  return (
    <div className="whole">
      {/* ----- Job Map ------ */}
      <Line data={myData} options={options} />
    </div>
  );
}
export default BusinessReports;
